module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nb-NO":{"required":"Vennligst tast inn gyldig verdi","error_msg":"Det har skjedd noe galt","error_validation_msg":"Vennligst rett feil i skjema, og deretter send inn på nytt"}}')
  delete Component.options._Ctor
}
